import { NON_REGISTRABLE_STATUS } from '@constants/NON_REGISTRABLE_STATUS';

/**
 * The course is registrable
 * - If the status is not in the NON_REGISTRABLE_STATUS array
 * - If the venue is not online
 * @param {Object} props
 * @param {Array} props.status
 * @param {Array} props.venues
 * @returns {boolean}
 */
function checkIfRegistrable({ status }) {
	if (!status) return false;

	return !NON_REGISTRABLE_STATUS.includes(status[0]?.slug);
}

export { checkIfRegistrable };
